import { AnalysisListContext } from "../context/AnalysisListContext";
import { useContext } from "react";

export const useAnalysisListContext = () => {
    const context = useContext(AnalysisListContext);

    if (!context) {
        return Error('useAnalysisListContext must be used inside an AnalysisListContextProvider');
    };

    return context;
};